import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function setAdminToken(token) {
  if (token) {
    api.defaults.headers.common["X-Admin-Token"] = token;
    localStorage.setItem("estrofa_admin_token", token);
  } else {
    delete api.defaults.headers.common["X-Admin-Token"];
    localStorage.removeItem("estrofa_admin_token");
  }
}

const stored = typeof window !== "undefined" ? localStorage.getItem("estrofa_admin_token") : null;
if (stored) {
  api.defaults.headers.common["X-Admin-Token"] = stored;
}
